module.exports = "/assets/data/b45d4a112db6a8ee6fad7a8394e613de-NE43.data.json";